import React, { useMemo } from 'react';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';
import { buildUnitSelectGroups } from '../../utils/unitSelectUtils';

const UnitSelect = ({
  value = '',
  onChange,
  units = [],
  product = null,
  disabled = false,
  compact = false,
  className = '',
  emptyLabel = '—',
  showCodeOnly = true,
}) => {
  const { productConversionsEnabled } = useModuleSettings();

  const groups = useMemo(
    () =>
      buildUnitSelectGroups({
        units,
        product,
        productConversionsEnabled,
      }),
    [units, product, productConversionsEnabled],
  );

  const optionLabel = (unit, { isCustom = false } = {}) => {
    if (isCustom && unit.label) return unit.label;
    return showCodeOnly ? unit.code : unit.label;
  };

  const selectClass = compact
    ? 'w-full h-[34px] px-2 py-1.5 text-sm border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100'
    : 'w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100';

  if (!groups.showGroups) {
    return (
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`${selectClass} ${className}`}
      >
        <option value="">{emptyLabel}</option>
        {groups.generalUnits.map((unit) => (
          <option key={unit.code} value={unit.code}>
            {optionLabel(unit)}
          </option>
        ))}
      </select>
    );
  }

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`${selectClass} ${className}`}
    >
      <option value="">{emptyLabel}</option>
      {groups.customUnits.length > 0 && (
        <optgroup label="Tasa personalizada">
          {groups.customUnits.map((unit) => (
            <option key={`custom-${unit.code}`} value={unit.code}>
              {optionLabel(unit, { isCustom: true })}
            </option>
          ))}
        </optgroup>
      )}
      <optgroup label="Unidad general">
        {groups.generalUnits.map((unit) => (
          <option key={`general-${unit.code}`} value={unit.code}>
            {optionLabel(unit)}
          </option>
        ))}
      </optgroup>
    </select>
  );
};

export default UnitSelect;
